import { types } from '../reducers/listTableReducer';

// eslint-disable-next-line import/prefer-default-export
export const createListTableElement = (values) => ({
  type: types.POST,
  payload: values,
});

export const updateListTable = (values) => ({
  type: types.PUT,
  payload: values,
});

export const removeListTableElement = (item) => ({
  type: types.DELETE,
  item,
});

export const reloadListTable = (items) => ({
  type: types.RELOAD,
  payload: items,
});

export const updateItemListTable = (item) => ({
  type: types.UPDATE_ITEM,
  payload: item,
});

export const updateRowTable =(items)=>({
  type: types.UPDATE_ROW,
  payload: {items}
});

export const updateAttributeOfItems = (items, atributeToUpdate) => ({
  type: types.UPDATE_ATRIBUTES,
  payload: { items, atributeToUpdate },
});

export const resetListTable = () => ({
  type: types.RESET,
});

export { getDraftId } from '../reducers/listTableReducer';
